var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "dialog",
      attrs: {
        title: _vm.titleDialog,
        visible: _vm.dialogVisible,
        "close-on-press-escape": false,
        width: "600px",
        center: "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.onHandleClose,
      },
    },
    [
      _c("div", { staticClass: "contents" }, [
        _c("div", { staticClass: "d-flex mb-15" }, [
          _c("div", { staticClass: "nameWrap" }, [_vm._v("属性名称:")]),
          _c("div", { staticClass: "ml10" }, [
            _vm._v(_vm._s(_vm.detailInfo.field_key)),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "d-flex",
            staticStyle: { "align-items": "self-start" },
          },
          [
            _c("div", { staticClass: "nameWrap" }, [_vm._v("属性值:")]),
            _c(
              "div",
              { staticClass: "ml10 boxWrap", staticStyle: { flex: "1" } },
              _vm._l(_vm.detailInfo.field_map, function (dItem, dIndex) {
                return _c("div", { key: dIndex, staticClass: "mb-10" }, [
                  _vm._v(" " + _vm._s(dItem) + " "),
                ])
              }),
              0
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }